var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2452 1.75996C7.90353 -0.584615 4.10458 -0.586946 1.75997 1.75473C-0.584608 4.09646 -0.586967 7.89544 1.75476 10.24C4.09643 12.5846 7.89545 12.587 10.2401 10.2453C12.5846 7.90358 12.587 4.10454 10.2452 1.75996ZM6.83775 9.80728C6.83775 9.89986 6.76273 9.97482 6.6702 9.97482H5.32982C5.2373 9.97482 5.16227 9.89986 5.16227 9.80728V4.83146C5.16227 4.73888 5.2373 4.66391 5.32982 4.66391H6.6702C6.76273 4.66391 6.83775 4.73885 6.83775 4.83146V9.80728ZM6.00001 3.96856C5.46422 3.96856 5.02828 3.53269 5.02828 2.99686C5.02828 2.46109 5.46419 2.02513 6.00001 2.02513C6.53584 2.02513 6.97175 2.46106 6.97175 2.99686C6.97175 3.53269 6.53578 3.96856 6.00001 3.96856Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIIcon);
export default __webpack_public_path__ + "static/media/i-icon.d10c074f69f2ce02803a5264035acb57.svg";
export { ForwardRef as ReactComponent };